module.exports = __webpack_public_path__ + "img/nasa-08-jaune.4be76fa9.svg";